import { ReactNode } from "react";

interface IListProps {
  data: ReactNode[];
  pointerCircle?: boolean;
}

function List(props: IListProps) {
  const { data } = props;
  let x = 1;

  const style = props.pointerCircle
    ? { listStyleType: "disc" }
    : { listStyleType: "square" };

  return (
    <div>
      <ol style={style}>
        {data.map((line) => (
          <li key={(x++).toString()}>
            <div style={{ fontSize: "18px" }}>{line}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default List;
